import * as React from "react";
import { useTranslation } from "react-i18next";
import "moment/locale/pt-br";
import { Box } from "@mui/system";
import { ListItem } from "./ListItem";
import { Typography } from "@mui/material";
import TitleAndDivider from "../TitleAndDivider";
import palette from "../../../common/styles/palette";

interface EventAdditionalInformationViewProps {
  event: any;
  statusRoom: any;
}

export default function EventAdditionalInformationView({
  event,
  statusRoom,
}: EventAdditionalInformationViewProps) {
  const { t } = useTranslation();

  const dataItem = [
    {
      icon: 'video_camera_front',
      title: 'title_report_event',
      description: 'description_report_event',
      url: '/dashboard/event/'
    },
    {
      icon: 'leaderboard',
      title: 'title_monitoring_room_class',
      description: 'description_monitoring_room_class',
      url: '/events/controlroom/'
    },
    {
      icon: 'file_copy',
      title: 'title_monitoring_room_files',
      description: 'description_monitoring_room_files',
      url: '/events/files/'
    },
    {
      icon: 'developer_board',
      title: 'title_data_ai',
      description: 'description_data_ai',
      url: '/events/data-ai/'
    },
  ]

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      gap={3}
    >
      <TitleAndDivider title={t('controls_and_content')}/>
      <Typography variant="body2" sx={{ color: palette.textMuted }}>
        {t('controls_and_content_info')}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 3,
        }}
      >
        {dataItem.map(item => (
          <ListItem
            key={item.url+event}
            title={t(item.title)}
            description={t(item.description)}
            urlClick={item.url + event}
            iconName={item.icon}
            // status_event_ended={statusRoom !== "Corrigido"}
          />
        ))}
      </Box>
    </Box>
  );
}
